import { BrowserRouter } from 'react-router-dom';

import './styles/global.css';
import Header from "./components/layout/Header/Header";
import Footer from "./components/layout/Footer/Footer";
import AppRoutes from './routes/AppRoutes';
import BotonWhatsapp from './components/ui/ButtonWhatsapp/ButtonWhatsapp';
import ScrollToTop from './components/common/ScrollToTop';

const App = () => {
    return (
        <>
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <AppRoutes />
            </BrowserRouter>
            <BotonWhatsapp />
            <Footer />
        </>
    );
};

export default App;
